import { render, staticRenderFns } from "./CulinaryCollections.vue?vue&type=template&id=53606303&scoped=true&"
import script from "./CulinaryCollections.vue?vue&type=script&lang=js&"
export * from "./CulinaryCollections.vue?vue&type=script&lang=js&"
import style0 from "./CulinaryCollections.vue?vue&type=style&index=0&id=53606303&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53606303",
  null
  
)

export default component.exports